import { useProgramFilter } from "@/stores";

export default defineNuxtRouteMiddleware((to) => {
  const programFilter = useProgramFilter();
  if (import.meta.client) {
    if (!to.path.startsWith("/online-degree-programs")) {
      programFilter.clearSession();
    }
  }
});
